import { useState } from 'react'
import { authApi } from '../api/authApi'
import { accountSignupSchema, zodErrorMessage, AccountSignupInput } from '@/shared/types'
import { notify } from '@/shared/utils'

interface UseSignupOptions {
  onSuccess: () => void
}

export function useSignup({ onSuccess }: UseSignupOptions) {
  const [loading, setLoading] = useState(false)

  const signup = async (input: AccountSignupInput) => {
    if (loading) return

    const result = accountSignupSchema.safeParse(input)
    if (!result.success) {
      notify.error(zodErrorMessage({ error: result.error }))
      return
    }

    try {
      setLoading(true)
      const response = await authApi.register(result.data)
      notify.success(response?.message || `OTP sent to ${input.phone}`)
      onSuccess()
    } catch (error: unknown) {
      const err = error as { message?: string }
      notify.error(err?.message || 'Failed to create account')
    } finally {
      setLoading(false)
    }
  }

  return { signup, loading }
}
